import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

const plans = [
  {
    name: "Starter",
    price: "$499",
    description: "Perfect for small businesses starting with AI.",
    features: [
      "1 Custom AI Agent",
      "Basic Integration",
      "Email Support",
      "1,000 Messages/mo",
      "Weekly Reports"
    ]
  },
  {
    name: "Pro",
    price: "$1,499",
    popular: true,
    description: "Advanced capabilities for growing teams.",
    features: [
      "3 Custom AI Agents",
      "Full API Access",
      "Priority Support",
      "10,000 Messages/mo",
      "Real-time Analytics",
      "Custom Knowledge Base"
    ]
  },
  {
    name: "Enterprise",
    price: "Custom",
    description: "Full-scale solution for large organizations.",
    features: [
      "Unlimited Agents",
      "On-premise Deployment",
      "24/7 Dedicated Support",
      "Unlimited Messages",
      "Custom SLA",
      "Dedicated Account Manager"
    ]
  }
];

export function Pricing() {
  return (
    <section id="pricing" className="py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Simple Pricing</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Choose the perfect plan to accelerate your business with AI.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <Card 
              key={index} 
              className={`relative flex flex-col ${plan.popular ? 'border-primary bg-primary/5' : 'bg-card/30 border-white/5'}`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-primary text-white text-xs font-bold rounded-full">
                  MOST POPULAR
                </div>
              )}
              <CardHeader className="text-center pb-8">
                <CardTitle className="text-xl font-medium text-muted-foreground mb-2">{plan.name}</CardTitle>
                <div className="text-4xl font-bold mb-2">{plan.price}</div>
                <p className="text-sm text-muted-foreground">{plan.description}</p>
              </CardHeader>
              <CardContent className="flex-grow">
                <ul className="space-y-4">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3 text-sm">
                      <Check className="w-4 h-4 text-primary flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
              <CardFooter>
                <Button className={`w-full ${plan.popular ? 'bg-primary hover:bg-primary/90' : 'bg-secondary hover:bg-secondary/80'}`}>
                  Get Started
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
